export interface Locale {
    name: string,
    code: string,
    xtmCode: string
};

export const LOCALES = [
    {
       name: 'English',
       code: 'en',
       xtmCode: 'en_NT'
    },
    {
       name: 'Afrikaans (South Africa)',
       code: 'af-ZA',
       xtmCode: 'af_ZA'
    },
    {
       name: 'Albanian',
       code: 'sq-AL',
       xtmCode: 'sq_AL'
    },
    {
       name: 'Amharic (Eritrea)',
       code: 'am_ER',
       xtmCode: 'am_ER'
    },
    {
       name: 'Amharic (Ethiopia)',
       code: 'am-ET',
       xtmCode: 'am_ET'
    },
    {
       name: 'Arabic',
       code: 'ar',
       xtmCode: 'ar_AA'
    },
    {
       name: 'Arabic (Algeria)',
       code: 'ar-DZ',
       xtmCode: 'ar_DZ'
    },
    {
       name: 'Arabic (Bahrain)',
       code: 'ar-BH',
       xtmCode: 'ar_BH'
    },
    {
       name: 'Arabic (Chad)',
       code: 'ar_TD',
       xtmCode: 'ar_TD'
    },
    {
       name: 'Arabic (Egypt)',
       code: 'ar-EG',
       xtmCode: 'ar_EG'
    },
    {
       name: 'Arabic (Iraq)',
       code: 'ar-IQ',
       xtmCode: 'ar_IQ'
    },
    {
       name: 'Arabic (Jordan)',
       code: 'ar-JO',
       xtmCode: 'ar_JO'
    },
    {
       name: 'Arabic (Kuwait)',
       code: 'ar-KW',
       xtmCode: 'ar_KW'
    },
    {
       name: 'Arabic (Lebanon)',
       code: 'ar-LB',
       xtmCode: 'ar_LB'
    },
    {
       name: 'Arabic (Libya)',
       code: 'ar-LY',
       xtmCode: 'ar_LY'
    },
    {
       name: 'Arabic (Mauritania)',
       code: 'ar_MR',
       xtmCode: 'ar_MR'
    },
    {
       name: 'Arabic (Morocco)',
       code: 'ar-MA',
       xtmCode: 'ar_MA'
    },
    {
       name: 'Arabic (Oman)',
       code: 'ar-OM',
       xtmCode: 'ar_OM'
    },
    {
       name: 'Arabic (Palestinian Territory)',
       code: 'ar_PS',
       xtmCode: 'ar_PS'
    },
    {
       name: 'Arabic (Qatar)',
       code: 'ar-QA',
       xtmCode: 'ar_QA'
    },
    {
       name: 'Arabic (Saudi Arabia)',
       code: 'ar-SA',
       xtmCode: 'ar_SA'
    },
    {
       name: 'Arabic (Sudan)',
       code: 'ar-SD',
       xtmCode: 'ar_SD'
    },
    {
       name: 'Arabic (Syria)',
       code: 'ar-SY',
       xtmCode: 'ar_SY'
    },
    {
       name: 'Arabic (Tunisia)',
       code: 'ar-TN',
       xtmCode: 'ar_TN'
    },
    {
       name: 'Arabic (United Arab Emirates)',
       code: 'ar-AE',
       xtmCode: 'ar_AE'
    },
    {
       name: 'Arabic (Western Sahara)',
       code: 'ar_EH',
       xtmCode: 'ar_EH'
    },
    {
       name: 'Arabic (Yemen)',
       code: 'ar-YE',
       xtmCode: 'ar_YE'
    },
    {
       name: 'Armenian',
       code: 'hy-AM',
       xtmCode: 'hy_AM'
    },
    {
       name: 'Assamese',
       code: 'as-IN',
       xtmCode: 'as_IN'
    },
    {
       name: 'Aymara',
       code: 'ay_BO',
       xtmCode: 'ay_BO'
    },
    {
       name: 'Azeri (Latin - Azerbaijan)',
       code: 'az_AZ_Latn',
       xtmCode: 'az_AZ_Latn'
    },
    {
       name: 'Bambara',
       code: 'bam',
       xtmCode: 'bam'
    },
    {
       name: 'Bashkir',
       code: 'ba_RU',
       xtmCode: 'ba_RU'
    },
    {
       name: 'Basque',
       code: 'eu',
       xtmCode: 'eu_ES'
    },
    {
       name: 'Belarusian (Belarus)',
       code: 'be_BY',
       xtmCode: 'be_BY'
    },
    {
       name: 'Bengali (Bangladesh)',
       code: 'bn-BD',
       xtmCode: 'bn_BD'
    },
    {
       name: 'Bengali (India)',
       code: 'bn-IN',
       xtmCode: 'bn_IN'
    },
    {
       name: 'Bosnian (Latin)',
       code: 'bs_BA_Latn',
       xtmCode: 'bs_BA_Latn'
    },
    {
       name: 'Bulgarian (Bulgaria)',
       code: 'bg-BG',
       xtmCode: 'bg_BG'
    },
    {
       name: 'Burmese',
       code: 'my',
       xtmCode: 'my_MM'
    },
    {
       name: 'Catalan',
       code: 'ca',
       xtmCode: 'ca_AD'
    },
    {
       name: 'Cebuano (used in Philippines)',
       code: 'ceb',
       xtmCode: 'ceb'
    },
    {
       name: 'Chinese (Cantonese)',
       code: 'zh_YUE',
       xtmCode: 'zh_YUE'
    },
    {
       name: 'Chinese (Simplified)',
       code: 'zh-CN',
       xtmCode: 'zh_CN'
    },
    {
       name: 'Chinese (Traditional)',
       code: 'zh-TW',
       xtmCode: 'zh_TW'
    },
    {
       name: 'Corsican',
       code: 'co',
       xtmCode: 'co_FR'
    },
    {
       name: 'Croatian',
       code: 'hr-HR',
       xtmCode: 'hr_HR'
    },
    {
       name: 'Czech',
       code: 'cs-CZ',
       xtmCode: 'cs_CZ'
    },
    {
       name: 'Danish',
       code: 'da',
       xtmCode: 'da_DK'
    },
    {
       name: 'Dari',
       code: 'prs_AF',
       xtmCode: 'prs_AF'
    },
    {
       name: 'Divehi',
       code: 'dv_IN',
       xtmCode: 'dv_IN'
    },
    {
       name: 'Dutch',
       code: 'nl-NL',
       xtmCode: 'nl_NL'
    },
    {
       name: 'English (UK)',
       code: 'en_GB',
       xtmCode: 'en_GB'
    },
    {
       name: 'English (US)',
       code: 'en_US',
       xtmCode: 'en_US'
    },
    {
       name: 'Esperanto',
       code: 'eo',
       xtmCode: 'eo'
    },
    {
       name: 'Estonian',
       code: 'et-EE',
       xtmCode: 'et_EE'
    },
    {
       name: 'Ewe (Ghana)',
       code: 'ee_GH',
       xtmCode: 'ee_GH'
    },
    {
       name: 'Faroese (Faroe Islands)',
       code: 'fo_FO',
       xtmCode: 'fo_FO'
    },
    {
       name: 'Fijian',
       code: 'fj',
       xtmCode: 'fj_FJ'
    },
    {
       name: 'Filipino',
       code: 'fp-PH',
       xtmCode: 'fil_PH'
    },
    {
       name: 'Finnish',
       code: 'fi-FI',
       xtmCode: 'fi_FI'
    },
    {
       name: 'French (Canada)',
       code: 'fr-CA',
       xtmCode: 'fr_CA'
    },
    {
       name: 'French (France)',
       code: 'fr-FR',
       xtmCode: 'fr_FR'
    },
    {
       name: 'Frisian',
       code: 'fy',
       xtmCode: 'fy'
    },
    {
       name: 'Galician (Spain)',
       code: 'gl-ES',
       xtmCode: 'gl_ES'
    },
    {
       name: 'Georgian',
       code: 'ka-GE',
       xtmCode: 'ka_GE'
    },
    {
       name: 'German (Germany)',
       code: 'de-DE',
       xtmCode: 'de_DE'
    },
    {
       name: 'Greek',
       code: 'el-GR',
       xtmCode: 'el_GR'
    },
    {
       name: 'Guarani',
       code: 'grn',
       xtmCode: 'grn'
    },
    {
       name: 'Gujarati',
       code: 'gu-IN',
       xtmCode: 'gu_IN'
    },
    {
       name: 'Haitian (Creole)',
       code: 'ht-HT',
       xtmCode: 'ht_HT'
    },
    {
       name: 'Hausa',
       code: 'ha',
       xtmCode: 'ha_NG'
    },
    {
       name: 'Hawaiian',
       code: 'haw',
       xtmCode: 'haw'
    },
    {
       name: 'Hebrew',
       code: 'he-IL',
       xtmCode: 'he_IL'
    },
    {
       name: 'Hindi',
       code: 'hi-IN',
       xtmCode: 'hi'
    },
    {
       name: 'Hmong',
       code: 'hm',
       xtmCode: 'hmn'
    },
    {
       name: 'Hungarian',
       code: 'hu',
       xtmCode: 'hu_HU'
    },
    {
       name: 'Icelandic',
       code: 'is-IS',
       xtmCode: 'is_IS'
    },
    {
       name: 'Igbo',
       code: 'ig',
       xtmCode: 'ig'
    },
    {
       name: 'Ilocano',
       code: 'ilo',
       xtmCode: 'ilo'
    },
    {
       name: 'Indonesian',
       code: 'id-ID',
       xtmCode: 'id_ID'
    },
    {
       name: 'Inuktitut',
       code: 'iu',
       xtmCode: 'iu'
    },
    {
       name: 'Irish (Gaelic)',
       code: 'ga-IE',
       xtmCode: 'ga_IE'
    },
    {
       name: 'Italian',
       code: 'it-IT',
       xtmCode: 'it_IT'
    },
    {
       name: 'Japanese',
       code: 'ja-JP',
       xtmCode: 'ja_JP'
    },
    {
       name: 'Javanese',
       code: 'jv',
       xtmCode: 'jv_ID'
    },
    {
       name: 'Kannada (India)',
       code: 'kn-IN',
       xtmCode: 'kn_IN'
    },
    {
       name: 'Kashmiri',
       code: 'ks',
       xtmCode: 'ks'
    },
    {
       name: 'Kazakh',
       code: 'kk-KZ',
       xtmCode: 'kk_KZ'
    },
    {
       name: 'Khmer',
       code: 'km_KH',
       xtmCode: 'km_KH'
    },
    {
       name: 'Kinyarwanda (Rwanda)',
       code: 'rw-RW',
       xtmCode: 'rw_RW'
    },
    {
       name: 'Konkani (India)',
       code: 'kok_IN',
       xtmCode: 'kok_IN'
    },
    {
       name: 'Korean',
       code: 'ko-KR',
       xtmCode: 'ko_KR'
    },
    {
       name: 'Krio',
       code: 'kri',
       xtmCode: 'kri'
    },
    {
       name: 'Kurdish (Iraq)',
       code: 'ku_IQ',
       xtmCode: 'ku_IQ'
    },
    {
       name: 'Kurdish (Kurmanji)',
       code: 'kmr',
       xtmCode: 'kmr'
    },
    {
       name: 'Kurdish (Sorani)',
       code: 'ku-CB',
       xtmCode: 'ckb'
    },
    {
       name: 'Kurdish (Türkiye)',
       code: 'ku-TR',
       xtmCode: 'ku_TR'
    },
    {
       name: 'Laothian',
       code: 'lo-LA',
       xtmCode: 'lo_LA'
    },
    {
       name: 'Latin',
       code: 'la',
       xtmCode: 'la'
    },
    {
       name: 'Latvian',
       code: 'lv-LV',
       xtmCode: 'lv_LV'
    },
    {
       name: 'Lingala',
       code: 'ln_CG',
       xtmCode: 'ln_CG'
    },
    {
       name: 'Lithuanian',
       code: 'lt-LT',
       xtmCode: 'lt_LT'
    },
    {
       name: 'Luganda',
       code: 'lug',
       xtmCode: 'lug'
    },
    {
       name: 'Luxembourgish',
       code: 'lb_LU',
       xtmCode: 'lb_LU'
    },
    {
       name: 'Macedonian',
       code: 'mk-MK',
       xtmCode: 'mk_MK'
    },
    {
       name: 'Malagasy (Madagascar)',
       code: 'mg-MG',
       xtmCode: 'mg_MG'
    },
    {
       name: 'Malay (Malaysia)',
       code: 'ms-MY',
       xtmCode: 'ms_MY'
    },
    {
       name: 'Malayalam (India)',
       code: 'ml-IN',
       xtmCode: 'ml_IN'
    },
    {
       name: 'Maltese',
       code: 'mt-MT',
       xtmCode: 'mt_MT'
    },
    {
       name: 'Manipuri',
       code: 'mni',
       xtmCode: 'mni'
    },
    {
       name: 'Maori',
       code: 'mi-NZ',
       xtmCode: 'mi_NZ'
    },
    {
       name: 'Marathi',
       code: 'mr-IN',
       xtmCode: 'mr_IN'
    },
    {
       name: 'Mizo Chin',
       code: 'lus',
       xtmCode: 'lus'
    },
    {
       name: 'Mongolian',
       code: 'mn-MN',
       xtmCode: 'mn_MN'
    },
    {
       name: 'Nepali',
       code: 'ne-NP',
       xtmCode: 'ne_NP'
    },
    {
       name: 'Norwegian (Bokmål)',
       code: 'nb-NO',
       xtmCode: 'nb_NO'
    },
    {
       name: 'Norwegian',
       code: 'no',
       xtmCode: 'no_NO'
    },
    {
       name: 'Nyanja',
       code: 'ny',
       xtmCode: 'ny'
    },
    {
       name: 'Oriya',
       code: 'or-IN',
       xtmCode: 'or_IN'
    },
    {
       name: 'Oromo',
       code: 'om_ET',
       xtmCode: 'om_ET'
    },
    {
       name: 'Pashto',
       code: 'ps',
       xtmCode: 'ps'
    },
    {
       name: 'Persian',
       code: 'fa-IR',
       xtmCode: 'fa_IR'
    },
    {
       name: 'Polish',
       code: 'pl-PL',
       xtmCode: 'pl_PL'
    },
    {
       name: 'Portuguese (Brazil)',
       code: 'pt-BR',
       xtmCode: 'pt_BR'
    },
    {
       name: 'Portuguese',
       code: 'pt-PT',
       xtmCode: 'pt_PT'
    },
    {
       name: 'Punjabi',
       code: 'pa_PA',
       xtmCode: 'pa_PA'
    },
    {
       name: 'Quechua',
       code: 'qu_PE',
       xtmCode: 'qu_PE'
    },
    {
       name: 'Romanian',
       code: 'ro-RO',
       xtmCode: 'ro_RO'
    },
    {
       name: 'Russian',
       code: 'ru-RU',
       xtmCode: 'ru_RU'
    },
    {
       name: 'Samoan',
       code: 'sm',
       xtmCode: 'sm_WS'
    },
    {
       name: 'Sanskrit',
       code: 'sa_IN',
       xtmCode: 'sa_IN'
    },
    {
       name: 'Scottish Gaelic (Scotland)',
       code: 'gd_GB',
       xtmCode: 'gd_GB'
    },
    {
       name: 'Serbian (Cyrillic)',
       code: 'sr-YR',
       xtmCode: 'sr_RS_Cyrl'
    },
    {
       name: 'Serbian – Serbia (Latin)',
       code: 'sr_RS_Latn',
       xtmCode: 'sr_RS_Latn'
    },
    {
       name: 'Sesotho',
       code: 'st',
       xtmCode: 'st'
    },
    {
       name: 'Setswana (Africa)',
       code: 'tn_ZA',
       xtmCode: 'tn_ZA'
    },
    {
       name: 'Shona',
       code: 'sn',
       xtmCode: 'sn'
    },
    {
       name: 'Sindhi',
       code: 'sd',
       xtmCode: 'sd_PK'
    },
    {
       name: 'Singhalese',
       code: 'si-LK',
       xtmCode: 'si_LK'
    },
    {
       name: 'Slovak',
       code: 'sk-SK',
       xtmCode: 'sk_SK'
    },
    {
       name: 'Slovenian',
       code: 'sl-SI',
       xtmCode: 'sl_SI'
    },
    {
       name: 'Somali',
       code: 'so-SO',
       xtmCode: 'so_SO'
    },
    {
       name: 'Spanish (Argentina)',
       code: 'es-AR',
       xtmCode: 'es_AR'
    },
    {
       name: 'Spanish (Bolivia)',
       code: 'es-BO',
       xtmCode: 'es_BO'
    },
    {
       name: 'Spanish (Chile)',
       code: 'es-CL',
       xtmCode: 'es_CL'
    },
    {
       name: 'Spanish (Colombia)',
       code: 'es-CO',
       xtmCode: 'es_CO'
    },
    {
       name: 'Spanish (Costa Rica)',
       code: 'es-CR',
       xtmCode: 'es_CR'
    },
    {
       name: 'Spanish (Cuba)',
       code: 'es_CU',
       xtmCode: 'es_CU'
    },
    {
       name: 'Spanish (Dominican Republic)',
       code: 'es-DO',
       xtmCode: 'es_DO'
    },
    {
       name: 'Spanish (Ecuador)',
       code: 'es-EC',
       xtmCode: 'es_EC'
    },
    {
       name: 'Spanish (El Salvador)',
       code: 'es-SV',
       xtmCode: 'es_SV'
    },
    {
       name: 'Spanish (Guatemala)',
       code: 'es-GT',
       xtmCode: 'es_GT'
    },
    {
       name: 'Spanish (Honduras)',
       code: 'es-HN',
       xtmCode: 'es_HN'
    },
    {
       name: 'Spanish (International)',
       code: 'es',
       xtmCode: 'es_001'
    },
    {
       name: 'Spanish (Latin America)',
       code: 'es-LA',
       xtmCode: 'es_419'
    },
    {
       name: 'Spanish (Mexico)',
       code: 'es-MX',
       xtmCode: 'es_MX'
    },
    {
       name: 'Spanish (Neutral)',
       code: 'es_NT',
       xtmCode: 'es_NT'
    },
    {
       name: 'Spanish (Nicaragua)',
       code: 'es-NI',
       xtmCode: 'es_NI'
    },
    {
       name: 'Spanish (Panama)',
       code: 'es-PA',
       xtmCode: 'es_PA'
    },
    {
       name: 'Spanish (Paraguay)',
       code: 'es-PY',
       xtmCode: 'es_PY'
    },
    {
       name: 'Spanish (Peru)',
       code: 'es-PE',
       xtmCode: 'es_PE'
    },
    {
       name: 'Spanish (Puerto Rico)',
       code: 'es-PR',
       xtmCode: 'es_PR'
    },
    {
       name: 'Spanish (Spain)',
       code: 'es-ES',
       xtmCode: 'es_ES'
    },
    {
       name: 'Spanish (United States)',
       code: 'es-US',
       xtmCode: 'es_US'
    },
    {
       name: 'Spanish (Uruguay)',
       code: 'es-UY',
       xtmCode: 'es_UY'
    },
    {
       name: 'Spanish (Venezuela)',
       code: 'es-VE',
       xtmCode: 'es_VE'
    },
    {
       name: 'Sudanese Arabic',
       code: 'apd_SD',
       xtmCode: 'apd_SD'
    },
    {
       name: 'Swahili',
       code: 'sw',
       xtmCode: 'swa'
    },
    {
       name: 'Swedish',
       code: 'sv-SE',
       xtmCode: 'sv_SE'
    },
    {
       name: 'Tagalog',
       code: 'tl-PH',
       xtmCode: 'tl_PH'
    },
    {
       name: 'Tahitian',
       code: 'ty',
       xtmCode: 'ty'
    },
    {
       name: 'Tajik',
       code: 'tg_TJ',
       xtmCode: 'tg_TJ'
    },
    {
       name: 'Tamil',
       code: 'ta-IN',
       xtmCode: 'ta_IN'
    },
    {
       name: 'Tatar',
       code: 'tt-RU',
       xtmCode: 'tt_RU'
    },
    {
       name: 'Telugu',
       code: 'te-IN',
       xtmCode: 'te_IN'
    },
    {
       name: 'Thai',
       code: 'th-TH',
       xtmCode: 'th_TH'
    },
    {
       name: 'Tibetan',
       code: 'bo',
       xtmCode: 'bo'
    },
    {
       name: 'Tigrinya',
       code: 'ti',
       xtmCode: 'ti'
    },
    {
       name: 'Tongan',
       code: 'to-TO',
       xtmCode: 'to_TO'
    },
    {
       name: 'Tsonga',
       code: 'ts_ZA',
       xtmCode: 'ts_ZA'
    },
    {
       name: 'Turkish',
       code: 'tr-TR',
       xtmCode: 'tr_TR'
    },
    {
       name: 'Turkmen',
       code: 'tk',
       xtmCode: 'tk_TM'
    },
    {
       name: 'Twi',
       code: 'tw',
       xtmCode: 'tw'
    },
    {
       name: 'Ukrainian',
       code: 'uk',
       xtmCode: 'uk_UA'
    },
    {
       name: 'Urdu',
       code: 'ur',
       xtmCode: 'ur_IN'
    },
    {
       name: 'Uyghur (China)',
       code: 'ug_CN',
       xtmCode: 'ug_CN'
    },
    {
       name: 'Uzbek (Afghanistan)',
       code: 'uz_AF',
       xtmCode: 'uz_AF'
    },
    {
       name: 'Uzbek (Latin)',
       code: 'uz_UZ_Latn',
       xtmCode: 'uz_UZ_Latn'
    },
    {
       name: 'Vietnamese',
       code: 'vi',
       xtmCode: 'vi_VN'
    },
    {
       name: 'Welsh',
       code: 'cy-GB',
       xtmCode: 'cy_GB'
    },
    {
       name: 'Xhosa (South Africa)',
       code: 'xh-ZA',
       xtmCode: 'xh_ZA'
    },
    {
       name: 'Yiddish',
       code: 'yi',
       xtmCode: 'yi'
    },
    {
       name: 'Yoruba',
       code: 'yo',
       xtmCode: 'yo_NG'
    },
    {
       name: 'Zulu (South Africa)',
       code: 'zu-ZA',
       xtmCode: 'zu_ZA'
    }
];
